// extracted by mini-css-extract-plugin
export default {"ntoAdContainer":"vvwV_XeoX4pnRS6QVJV0","margin":"bGobcxmiFsQExH8rcVkB"};